import React, { useContext } from "react";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from "react-router-dom";
// import AlertContext from "../Contexts/AlertContext";
// import AlertTypes from "../Enums/AlertTypes";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InfoIcon from '@mui/icons-material/Info';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';

function MenuInfo({ next, len }: { next: any, len: number }) {

    // const {alert, setShowAlert} = useContext(AlertContext);
    // const navigate = useNavigate();

    return (
        <div className="bg-transparent w-100 h-100" style={{ position: "fixed", top: 0}}>
            <div className="rounded-circle bg-transparent intro_pointing" style={{
                width: "40px",
                height: "40px",
                left: "36px",
                top: "27px",
            }}/>
            <div className="rounded-circle bg-transparent" style={{
                width: "40px",
                height: "40px",
                border: "solid 270px rgba(255, 255, 255, 0.9)",
                boxSizing: "content-box",
                position: "absolute",
                left: "36px",
                top: "27px",
                transform: "translateX(-50%) translateY(-50%)"
            }}>
                <div className="bg-transparent p-3" style={{
                    width: "250px",
                    position: "absolute",
                    left: "20%",
                    top: "110%"
                }}>
                    <p className="text-dark mb-1" style={{fontSize: "11px", fontWeight: "bolder"}} >
                        Welcome to Nuwa Mobile from Nuwa Technologies
                    </p>
                    <p className="text-dark lead mb-3" style={{fontSize: "11px"}}>
                        You can click and view hidden options such as About Us, Frequently Asked Questions and Nuwa Blogs
                    </p>

                    <div className="d-flex justify-content-between">
                        <button className="btn btn-sm btn-danger" onClick={() => {next(len, null);}}>
                            Exit Tour
                            <CloseIcon sx={{fontSize: "15px", marginLeft: "10px"}} />
                        </button>
                        <button className="btn btn-sm btn-dark" onClick={() => {next(len);}}>
                            Next
                            <ArrowForwardIosIcon sx={{fontSize: "15px", marginLeft: "10px"}} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MenuInfo;